import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontfamily/fontfamilycommand
 */
import FontCommand from "../fontcommand";
import { FONT_FAMILY } from "../utils";
/**
 * The font family command. It is used by {@link module:font/fontfamily/fontfamilyediting~FontFamilyEditing}
 * to apply the font family.
 *
 *		editor.execute( 'fontFamily', { value: 'Arial' } );
 *
 * **Note**: Executing the command without the value removes the attribute from the model.
 *
 * @extends module:font/fontcommand~FontCommand
 */

var FontFamilyCommand = /*#__PURE__*/function (_FontCommand) {
  _inherits(FontFamilyCommand, _FontCommand);

  var _super = _createSuper(FontFamilyCommand);

  /**
   * @inheritDoc
   */
  function FontFamilyCommand(editor) {
    _classCallCheck(this, FontFamilyCommand);

    return _super.call(this, editor, FONT_FAMILY);
  }

  return FontFamilyCommand;
}(FontCommand);

export { FontFamilyCommand as default };